'use strict';

export function medicineBatchGrid(options){

    if (!options.gridURL){
        //EQLAPP.STRIPE.showAlert({title: 'Alert', body: 'Grid URL Missing'});return false;
    };
    if (!options.selector){
        EQLAPP.STRIPE.showAlert({title: 'Alert', body: 'Grid Object Missing'});return false;
    };
    if (!options.grid){
        EQLAPP.STRIPE.showAlert({title: 'Alert', body: 'Grid Name Missing'});return false;
    };
    if (!options.pager){
        EQLAPP.STRIPE.showAlert({title: 'Alert', body: 'Pager Name Missing'});return false;
    };
    if (!options.startRows){
        options.startRows = 10;
    };
    if (!options.width){
        options.width = 730;
    };

    $(options.selector).jqGrid({
        datatype: 'local',
        caption: 'Batch History',
        hidegrid: false,
        autowidth: false,
        width: options.width,
        height: '100%',
        pager: options.pager,
        colNames: [
            $.i18n('ID'),
            $.i18n('ACTIVITYCODEID'),
            $.i18n('BATCH_NUMBER'),
            $.i18n('EXPIRY_DATE'),
            '',
            $.i18n('EDIT'),
            $.i18n('DELETE'),
        ],
        colModel: [
            {
                name: 'ID', index: 'ID',
                align: 'left', width: 15,hidden: true,
            },
            {
                name: 'ACTIVITYCODEID', index: 'ACTIVITYCODEID',
                align: 'left', width: 15, hidden: true,
            },
            {
                name: 'BATCHNUMBER', index: 'BATCHNUMBER',
                align: 'left', sortable: true, sorttype: 'text', width: 15, hidden: false,
            },
            {
                name: 'BATCHEXPIRY', index: 'BATCHEXPIRY',
                align: 'center', sortable: true, sorttype: 'date', width: 10,editable: false,
                searchoptions: {sopt: ['bw']},
                formatter: 'date',
                formatoptions: {
                    srcformat: 'Y-m-d',
                    newformat: jsDateFormatString,
                },
            },
            {
                name: 'INUSE', index: 'INUSE',
                align: 'left', width: 15,hidden: true,
            },
            {
                name: 'Edit', index: 'Edit',
                align: 'left', classes: 'option edit', width: 5, sorttype: 'text',
                edittype: 'select',
                cellattr: function (rowId) {
                    if (rowId > 0){
                        return 'title="Edit Batch Details" class="option edit"';
                    }
                },
            },
            {
                name: 'Delete', index: 'Delete',
                align: 'left', classes: 'option remove', width: 5, sorttype: 'text',
                edittype: 'select',
                cellattr: function(rowId,val,rawObject,cm,rData){
                    if (rowId > 0){
                        if ((rData.BATCHNUMBER.length > 0) && (rData.INUSE == '')){
                            return 'title="Delete Batch Details" class="option remove"';
                        } else {
                            return 'title="" class=""';
                        }
                    }
                },
            },
        ],
        rowNum: options.startRows,
        gridComplete: function(){
            gridFix(options.selector);
        },
        onCellSelect: function(rowid,iCol,cellcontent,e){
            var batchID = $(options.selector).jqGrid('getCell',rowid,'ID');
            var activityCodeID = $(options.selector).jqGrid('getCell',rowid,'ACTIVITYCODEID');
            var inUse = $(options.selector).jqGrid('getCell',rowid,'INUSE');
            if (iCol == 5 && $(e.srcElement).hasClass('edit')){

                medicineBatchEdit({
                    batchID: batchID,
                    activityCodeID: activityCodeID,
                    inUse: inUse,
                });

            }

            if (iCol == 6 && $(e.srcElement).hasClass('remove')){
                var yesButtonText = $.i18n('DELETE_BATCH');
                var closeButtonText = $.i18n('CANCEL');

                var deleteMedicineBatchURL = '/components/general.cfc?' + jQuery.param({
                    'method': 'deleteItem',
                    'dbTable': 'medicineBatch',
                    'dbIDs': batchID,
                    'randomVar': gen_random(),
                    'csrfkey': $('#csrfkey').val(),
                });

                popWin({
                    title: $.i18n('DELETE_BATCH'),
                    modal: true,
                    classes: 'deletePaymentPopup',
                    contents: $.i18n('CONFIRM_DELETE'),
                    buttons: {
                        [yesButtonText]: function(){
                            $.ajax({
                                type: 'POST',
                                url: deleteMedicineBatchURL,
                                data: gen_random(),
                                dataType: 'json',
                                cache: false,
                                success: function(data){
                                    if (data.SAVED){
                                        popWinClose();
                                        $(options.selector).trigger('reloadGrid');
                                    } else {
                                        EQLAPP.STRIPE.showAlert({
                                            title: $.i18n('ALERT'),
                                            body: data.RESULTMSG});
                                    }
                                },
                                error: function() {
                                    var errorMsg = 'An issue occured while attempting to';
                                    errorMsg += ' delete the Medicine Batch. Please try again';
                                    EQLAPP.STRIPE.showAlert({
                                        title: 'Alert',
                                        body: errorMsg,
                                    });
                                },
                            });
                        },
                        [closeButtonText]: function(){
                            popWinClose();
                        },
                    },
                });
            }
        },
    }).navGrid(
        '#' + options.pager,
        {
            edit: false,
            add: false,
            del: false,
            search: false,
            refresh: false,
        },
    ).navButtonAdd('#' + options.pager,{
        caption: '',
        buttonicon: 'ui-icon-plus',
        onClickButton: function(){
            if ((!options.activityCodeID) || (options.activityCodeID == 0)){
                var alertMessage = 'Activity Code ID Missing, ';
                alertMessage += 'Please Save Activity Code Record and try again.';
                EQLAPP.STRIPE.showAlert(
                    {
                        title: 'Alert',
                        body: alertMessage,
                    });
                return false;
            };

            medicineBatchEdit({
                activityCodeID: options.activityCodeID,
            });

        },
        position: 'last',
    });
}

export function medicineBatchEdit(options){
    if (!options.activityCodeID){
        EQLAPP.STRIPE.showAlert({title: 'Alert', body: 'Activity Code Missing'});return false;
    };
    if (!options.batchID){
        options.batchID = 0;
    };
    if (!options.inUse){
        options.inUse = 0;
    };

    var popURL = '/pages/pop/?' + jQuery.param({
        module: 'medicine',
        page: 'batch_edit',
        batchID: options.batchID,
        activityCodeID: options.activityCodeID,
        inUse: options.inUse,
    });
    if (options.batchID == 0){
        var popupTitle = $.i18n('ADD_BATCH');
    }
    else {
        var popupTitle = $.i18n('EDIT_BATCH');
    }
    popWin({
        title: popupTitle,
        noAutoWidth: true,
        popID: 'medicineEditBatch',
        width: 400,
        modal: true,
        page: popURL,
        buttons: {
            'Save': function () {
                $('#form_edit_batch').submit();
            },
            'Close': function () {
                $(this).dialog('close');
            },
        },
    });

}

export function medicineBatchDropDownReset(options){

    if (!options.selector){
        EQLAPP.STRIPE.showAlert({
            title: 'Alert',
            body: 'Drop Down Selector Missing'});
        return false;
    };
    if (!options.activityCodeID){
        EQLAPP.STRIPE.showAlert({
            title: 'Alert',
            body: 'Activity Code ID Missing'});
        return false;
    };
    if (!options.selectedBatch){
        options.selectedBatch = '';
    };

    var batchURL = '/components/medicine.cfc?' + jQuery.param({
        'method': 'getMedicineBatchDropDownWeb',
        'activityCodeID': options.activityCodeID,
    });

    var batchDropDown = options.selector;

    $.ajax({
        type: 'GET',
        url: batchURL,
        data: gen_random(),
        dataType: 'JSON',
        cache: false,
        success: function(data){
            if (data.length > 0){

                // Rebuild dropdown data for Activity Code
                batchDropDown.empty();
                // Update DropDown
                var optionElement = document.createElement('option');
                optionElement.value = '';
                optionElement.textContent = '';
                batchDropDown.append(optionElement);
                for (var i = 0; i < data.length; i++) {
                    var batchID = data[i].batchID;
                    var batchExpiryListItem = data[i].BatchExpiryListItem;

                    // Create an option element
                    var optionElement = document.createElement('option');
                    optionElement.value = batchID;
                    optionElement.textContent = batchExpiryListItem;

                    // Set the selected attribute if it matches the selected batch
                    // or select first on the list if expiry date is bigger than work date
                    if (options.selectedBatch == batchID) {
                        optionElement.selected = true;
                    } else if (options.selectedBatch == '' && i == 0) {
                        // Get batch expiry and activity date
                        // and use last batch if date is still valid
                        var batchExpiry = data[i].BatchExpiryDate;
                        const batchExpiryDate = new Date(batchExpiry);
                        batchExpiryDate.setHours(0, 0, 0, 0);
                        const activityDate = new Date(options.activityDate);
                        activityDate.setHours(0, 0, 0, 0);

                        if (batchExpiryDate >= activityDate) {
                            optionElement.selected = true;
                        }
                    }

                    // Append the option element to the dropdown
                    batchDropDown.append(optionElement);
                }

            } else {
                //No matching records found
            }
        },
        error: function(){
            EQLAPP.STRIPE.showAlert({
                title: 'Alert',
                body: 'Unable to connect to Equisoft Live at this time. Please try again.',
            });
        },
    });
}

export function horseInquiryMedicineGrid(options){

    if (!options.selector){
        EQLAPP.STRIPE.showAlert({title: 'Alert', body: 'Grid Object Missing'});return false;
    };
    if (!options.horseID){
        EQLAPP.STRIPE.showAlert({title: 'Alert', body: 'Horse ID Missing'});return false;
    };

    var medicationURL = '/components/horse.cfc?' + jQuery.param({
        method: 'getHorseInquiryDetails',
        jqGrid: true,
        horseID: options.horseID,
        dateFrom: options.dateFrom,
        dateTo: options.dateTo,
        medicineOnly: true,
    });

    $(options.selector).jqGrid({

        url: medicationURL
        ,datatype: 'json'
        ,colNames: [
            'ID'
            ,'Date'
            ,'Description'
            ,'VPA Number'
            ,'Batch'
            ,'Expiry'
            ,'Route'
            ,'Dosage',
        ]
        ,colModel: [
            {name: 'ID',
                index: 'ID',
                width: 0,
                sorttype: 'int',
                hidden: true,
                editable: false}
            ,{name: 'Date'
                ,index: 'Date'
                ,width: 10
                ,formatter: 'date'
                ,formatoptions: {
                    srcformat: 'Y-m-d',
                    newformat: jsDateFormatString},
                sorttype: 'Date',
            }
            ,{name: 'Description',index: 'Description',width: 40,sorttype: 'text'}
            ,{name: 'VPANumber',width: 20, align: 'center',sortable: false,}
            ,{name: 'BatchNumber',width: 20, align: 'center',sortable: false,}
            ,{name: 'BatchExpiry',width: 10, align: 'center',sortable: false,
                formatter: 'date'
                ,formatoptions: {
                    srcformat: 'Y-m-d',
                    newformat: jsDateFormatString}
                ,sorttype: 'Date',
            }
            ,{name: 'MedicineRoute',width: 20, align: 'center',sortable: false,}
            ,{name: 'MedicineDosage',width: 20, align: 'center',sortable: false,}
        ]
        ,rowNum: 10
        ,rowList: [10,20,30]
        ,width: '720'
        ,height: '100%'
        ,pager: '#jqGridHorseTabMedicationPager'
        ,sortname: 'ID'
        ,viewrecords: true
        ,sortorder: 'desc'
        ,gridComplete: function()
        {
            gridFix($(options.selector));
        },
    });
}
